<template>
  <div class="download_customer" :class="{ reverse: !innerModel.visible && outModel.visible }">
    <div class="download_customer-item" :class="{ 'white-mode': mode == 'user' }" v-if="innerModel.visible"
      @click="linkTo(innerModel.url)">
      <img src="../../../static/img/inner_download.png" />
      <span>{{ innerModel.name }}</span>
    </div>
    <div class="split-line"
      v-if="(innerModel.visible && outModel.visible) || ((innerModel.visible || outModel.visible) && mode == 'user')"
      :class="{ 'line-right': mode == 'user' }"></div>
    <div class="download_customer-item" v-if="outModel.visible" @click="linkTo(outModel.url)"
      :class="{ 'white-mode': mode == 'user' }">
      <img src="../../../static/img/out_download.png" />
      <span>{{ outModel.name }}</span>
    </div>
  </div>
</template>

<script>
import api from "@/assets/js/api";
export default {
  name: "DownloadCustomer",
  props: {
    /** 加载方式 sysParams：系统参数 user： 用户类型  */
    mode: {
      type: String,
      default: "sysParams"
    }
  },
  data () {
    return {
      /** 内部客户端控制 */
      innerModel: {
        visible: false,
        name: "内部用户客户端下载",
        url: ""
      },
      /** 外部客户端控制 */
      outModel: {
        visible: false,
        name: "外部用户客户端下载",
        url: ""
      }
    };
  },
  methods: {
    /** 获取内部客户端信息 */
    getInnerInfo () {
      api.menu
        .commonPathGetOneSysParameter("internal_client_download")
        .then(res => {
          if (res.data.code == "0") {
            const info = res.data.data;
            this.innerModel = {
              visible: info.value != "0",
              name: info.name,
              url: info.value
            };
          }
        });
    },
    /** 获取外部客户端信息 */
    getOutInfo () {
      api.menu
        .commonPathGetOneSysParameter("external_client_download")
        .then(res => {
          if (res.data.code == "0") {
            const info = res.data.data;
            this.outModel = {
              visible: info.value != "0",
              name: info.name,
              url: info.value
            };
          }
        });
    },
    /** 跳转下载 */
    linkTo (url) {
      window.open(url);
    }
  },
  mounted () {
    if (this.mode == "sysParams") {
      this.getInnerInfo();
      this.getOutInfo();
    } else {
      // 这样写第一次登录获取不到 干脆调接口
      // const userInfo = JSON.parse(sessionStorage.getItem("currentUser"));
      api.user.currentUserInfo().then(res => {
        if (res.data.code == "0") {
          let currentUser = res.data.data;
          const userType = currentUser.userType;
          // 1 是管理员 都不显示
          switch (userType) {
            case "2":
              this.getInnerInfo();
              break;
            case "3":
            case "4":
              this.getOutInfo();
              break;
            default:
              break;
          }
        }
      });
    }
  }
};
</script>

<style scoped>
.download_customer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.download_customer .download_customer-item {
  display: flex;
  align-items: center;
  cursor: pointer;
  overflow: hidden;
}

.download_customer .white-mode {
  filter: brightness(1000%);
}

.download_customer .download_customer-item>span {
  color: #409EFF;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
}

.download_customer .download_customer-item>img {
  width: 20px;
  margin-right: 8px;
  flex-shrink: 0;
}

.download_customer .split-line {
  flex: 1;
  min-width: 20px;
  position: relative;
  display: flex;
  height: 16px;
  justify-content: center;
}

.download_customer .split-line::after {
  content: "";
  position: absolute;
  height: 16px;
  width: 1px;
  background-color: #DCDCDC;
  top: 0;
  bottom: 0;
}

.download_customer .line-right {
  margin: 0 24px;
}

.download_customer .line-right::after {
  background-color: #5f709c;
}

.reverse {
  flex-direction: row-reverse;
}
</style>



// WEBPACK FOOTER //
// src/components/common/DownloadCustomer.vue